import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  IvyListUrl = `${AppSettings.API_ENDPOINT}/${'get-ivr-survey'}`;
  surveyListUrl =  `${AppSettings.API_ENDPOINT}/${'get-survey-master'}`;
  audioFileUrl = `${AppSettings.API_ENDPOINT}/${'download_audio'}`;

  constructor(private http: HttpClient) { }

  ivyListData(){
    return this.http.get(this.IvyListUrl);
  }

  surveyListData(data:any){
    return this.http.post(this.surveyListUrl, data);
  }
  getAudioFile(id:string){
    return this.http.get(`${this.audioFileUrl}/${id}`, {responseType: 'blob' as 'json'});
  }
}
